import { BASEMAPLEGEND } from "../../actions/portal/";

export default function(state = null, action) {
  switch (action.type) {
    case BASEMAPLEGEND:
      return action.payload;
    default:
  }

  return state;
}
